"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CheckoutSummary = void 0;
var _checkoutSummary = require("@ori/checkout-summary");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _contexts = require("../contexts");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const LazyCheckoutSummary = /*#__PURE__*/ (0, _react.lazy)(async ()=>({
        default: (await Promise.resolve().then(()=>_interopRequireWildcard(require('@ori/checkout-summary')))).App
    }));
const CheckoutSummary = ()=>{
    const configuration = (0, _contexts.useCheckout)();
    const { continueButtonTooltip, isPaymentModelLoading, paymentModel, setCurrentStep, selectedStep, setIsRegistrationVisible } = (0, _contexts.useNavigationContext)();
    const isOnlinePaymentMethod = !isPaymentModelLoading && (paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.paymentProviderGroups.some((group)=>group.paymentProviders.some((provider)=>provider.id === paymentModel.selectedPaymentProviderId && (provider.paymentMethodType === _globalApiClientReact.GlobalShoppingPaymentMethodDtoPaymentMethod.Online || provider.paymentMethodType === 'Online'))));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Suspense, {
        fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_checkoutSummary.SummarySkeleton, {}),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LazyCheckoutSummary, {
            continueButtonTooltip: continueButtonTooltip,
            isOnlinePaymentMethod: isOnlinePaymentMethod,
            selectedStep: selectedStep,
            setCurrentStep: setCurrentStep,
            setIsRegistrationVisible: setIsRegistrationVisible,
            ...configuration
        })
    });
};
exports.CheckoutSummary = CheckoutSummary;
